<h3>{{'DASHBOARD.SHARE_MESSAGE' | translate}}: {{data.name}}</h3>

<mat-form-field class="w100 mt-3">
    <mat-label>{{'TITLES.USERS' | translate}}</mat-label>
    <mat-select [formControl]="selectUsers" multiple (selectionChange)="selectChange($event)">
        <mat-option *ngFor="let user of userCollection" [value]="user">{{user.user | titlecase}}</mat-option>
    </mat-select>
</mat-form-field>

<div class="mt-3">
    <button mat-raised-button [mat-dialog-close]>{{'DASHBOARD.FORM.CANCEL' | translate}}</button>
    <button [disabled]="usersSelected.length <= 0" mat-raised-button color="primary" class="right" [mat-dialog-close]="usersSelected"
        cdkFocusInitial>{{'DASHBOARD.FORM.ACCEPT' | translate}}</button>
</div>